module.exports = __webpack_public_path__ + "static/media/Pool5.cceb197b.jpg";